'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var index = require('../../providers/ClaimBuilder/index.js');
var useTitanAnalytics = require('../../providers/titan/useTitanAnalytics.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const ItemRemoveConfirmationContext = /*#__PURE__*/React__default["default"].createContext(null);
const useItemRemoveConfirmation = () => {
  const context = React.useContext(ItemRemoveConfirmationContext);
  if (!context) {
    throw new Error('No context provided for ItemRemoveConfirmation provider');
  }
  return context;
};
const ItemRemoveConfirmationProvider = _ref => {
  let {
    children,
    value: {
      currentItemDetails,
      currentItemClaim
    }
  } = _ref;
  const [state, setState] = React.useState(undefined);
  const titan = useTitanAnalytics["default"]();
  const {
    handleRemoveClaimedItem,
    handleNavigateBack
  } = index.useClaimBuilder();
  const onCancel = () => {
    handleNavigateBack();
  };
  const onRemove = () => {
    if (state === 'yes') {
      titan === null || titan === void 0 ? void 0 : titan.track({
        event: 'product_removed',
        properties: {
          product_id: currentItemDetails === null || currentItemDetails === void 0 ? void 0 : currentItemDetails.itemId,
          sku: currentItemDetails === null || currentItemDetails === void 0 ? void 0 : currentItemDetails.sku,
          name: currentItemDetails === null || currentItemDetails === void 0 ? void 0 : currentItemDetails.name
        }
      })
      // eslint-disable-next-line no-console
      .catch(e => console.error(e));
      handleRemoveClaimedItem();
    } else {
      onCancel();
    }
  };
  return /*#__PURE__*/React__default["default"].createElement(ItemRemoveConfirmationContext.Provider, {
    value: {
      itemDetails: currentItemDetails,
      claimDetails: currentItemClaim,
      state,
      setState,
      onRemove,
      onCancel
    }
  }, children);
};

exports.ItemRemoveConfirmationContext = ItemRemoveConfirmationContext;
exports.ItemRemoveConfirmationProvider = ItemRemoveConfirmationProvider;
exports.useItemRemoveConfirmation = useItemRemoveConfirmation;
